<template>
  <div :class="bgClass" id="app">
    <!-- <div :class="bgClass"></div> -->

    <div class="nav">
      <ul class="nav-menu">
        <li :class="classA" :style="{ color: fontColor }" @click="clickA">
          呆小鱼工作室
        </li>
        <li :class="classB" @click="clickB">热销</li>
        <li :class="classC" @click="clickC">新品</li>
        <li :class="classD" @click="clickD">付费资讯</li>
      </ul>
    </div>
    <div v-show="showFirst" id="first-bg" class="web-bg"></div>
    <div v-show="showSecond" id="second-bg" class="web-bg">
      <div class="btn-wrap">
        <el-button v-if="showSecond" round @click="open(titleE, contentE)"
          >购买评测</el-button
        >
      </div>
    </div>
    <div v-show="showThird" id="third-bg" class="web-bg"></div>
    <div v-show="showForth" id="forth-bg" class="web-bg">
      <div class="charge-wrap">
        <div class="charge-wrap-row">
          <img
            src="./assets/MemberCard1.jpg"
            alt
            class="charge-img"
            @click="open(titleA, contentA)"
          />
          <img
            src="./assets/MemberCard2.jpg"
            alt
            class="charge-img"
            @click="open(titleB, contentB)"
          />
        </div>
        <div class="charge-wrap-row">
          <img
            src="./assets/MemberCard3.jpg"
            alt
            class="charge-img"
            @click="open(titleC, contentC)"
          />
          <img
            src="./assets/MemberCard4.jpg"
            alt
            class="charge-img"
            @click="open(titleD, contentD)"
          />
        </div>
      </div>
    </div>
    <!-- <div class="btn-wrap">
      <el-button v-if="showForth" round @click="open">成为会员</el-button>
    </div>-->
    <div class="footer-wrap">
      <div class="footer" :style="{ background: footerStyle }">
        <p class="footer-info">
          &copy;2019 FatFootFish | ALL RIGHTS RESERVED
          <br />邮箱/Email: biz@fatfootfish.com
        </p>
        <p class="footer-copyright">
          <a target="_blank" href="http://beian.miit.gov.cn">京B2-20200497</a>
          <br /><img src="@/assets/emblem.png" style="float: left;" />
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202008923">京公网安备 11010202008923号</a>
        </p>
      </div>
    </div>
    <link id="dataJson" rel="import" href="<%= BASE_URL %>data.json" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFirst: true,
      showSecond: false,
      showThird: false,
      showForth: false,
      classA: "nav-menu-item is-active",
      classB: "nav-menu-item",
      classC: "nav-menu-item",
      classD: "nav-menu-item",
      footerStyle: "",
      fontColor: "#fff",
      bgClass: "home-bg",
      contentA: "",
      contentB: "",
      contentC: "",
      contentD: "",
      contentE: "",
      titleA: "",
      titleB: "",
      titleC: "",
      titleD: "",
      titleE: "",
      baseUrl: process.env.VUE_APP_BASE_URL,
      json: "",
    };
  },
  mounted() {
    let json = require("@/assets/static/data.json");
    this.contentA = json.contentA;
    this.contentB = json.contentB;
    this.contentC = json.contentC;
    this.contentD = json.contentD;
    this.contentE = json.contentE;
    this.titleA = json.titleA;
    this.titleB = json.titleB;
    this.titleC = json.titleC;
    this.titleD = json.titleD;
    this.titleE = json.titleE;
  },
  methods: {
    clickA() {
      this.classA = "nav-menu-item is-active";
      this.classB = "nav-menu-item";
      this.classC = "nav-menu-item";
      this.classD = "nav-menu-item";
      this.showFirst = true;
      this.showSecond = false;
      this.showThird = false;
      this.showForth = false;
      this.footerStyle = "#2d0a04";
      this.bgClass = "home-bg";
    },
    clickB() {
      this.classA = "nav-menu-item";
      this.classB = "nav-menu-item is-active";
      this.classC = "nav-menu-item";
      this.classD = "nav-menu-item";
      this.showFirst = false;
      this.showSecond = true;
      this.showThird = false;
      this.showForth = false;
      this.footerStyle = "none";
      this.bgClass = "trending-bg";
    },
    clickC() {
      this.classA = "nav-menu-item";
      this.classB = "nav-menu-item";
      this.classC = "nav-menu-item is-active";
      this.classD = "nav-menu-item";
      this.showFirst = false;
      this.showSecond = false;
      this.showThird = true;
      this.showForth = false;
      this.footerStyle = "none";
      this.bgClass = "new-bg";
    },
    clickD() {
      this.classA = "nav-menu-item";
      this.classB = "nav-menu-item";
      this.classC = "nav-menu-item";
      this.classD = "nav-menu-item is-active";
      this.showFirst = false;
      this.showSecond = false;
      this.showThird = false;
      this.showForth = true;
      this.footerStyle = "none";
      this.bgClass = "member-bg";
    },
    open(title, content) {
      console.log(title);
      this.$confirm(content, title, {
        distinguishCancelAndClose: true,
        confirmButtonText: "付费阅读全文",
        cancelButtonText: "放弃",
      }).then(() => {
        this.openInner();
      });
    },
    openInner() {
      this.$prompt("请输入邮箱", "会员注册", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "邮箱格式不正确",
      }).then(() => {
        this.$message({
          type: "success",
          message: "注册成功！",
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import "./main.scss";

body {
  background: #2d0a04;
  display: flex;
  justify-content: center;
}

@include respond-above(md) {
  #app {
    width: 1000px;
    margin: auto;
  }
}

.nav {
  position: absolute;
  top: 0;
  width: 100%;
  height: 60px;

  &-menu {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    list-style: none;
    margin: 0;
    padding: 0;

    &-item {
      color: #fff;
      font-family: SimHei, Arial, Helvetica, sans-serif;
      font-weight: 700;
      width: 100%;
      text-align: center;
      line-height: 60px;
      opacity: 0.7;
      background: #2d0a04;
      font-size: 12px;

      &:hover {
        color: #fff;
        background: #666;
        border-bottom: 0;
      }

      &.is-active {
        color: #2d0a04;
        background: none;
      }
    }
  }
}

.web-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.charge-wrap {
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  // margin: auto;
  &-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 10px 0;
  }

  .charge-img {
    max-width: 400px;
    max-height: 225px;
    margin: 0 10px;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
}

.footer-wrap {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.footer {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  color: #34575b;
  opacity: 0.7;
  background: #2d0a04;
  padding-left: 1em;
  padding-right: 1em;
  font-weight: 700;

  &-info {
    border-top: 1px solid #34575b;
    padding-top: 5px;
  }

  &-copyright {
    border-top: 1px solid #34575b;
    padding-top: 5px;
    text-align: right;

    a {
      color: #34575b;
    }
  }
}

.btn-wrap {
  // margin-top: 50%;
  position: absolute;
  bottom: 20%;
  width: 100%;
  display: flex;
  justify-content: center;

  .el-button {
    background: #2d0a04;
    color: #fff;
    opacity: 0.9;
    width: 400px;
    height: 50px;

    &:hover {
      color: #fff;
      background: #666;
    }

    &:focus {
      background: #2d0a04;
      color: #fff;
      opacity: 0.9;
    }
  }
}

#first-bg {
  background: url("./assets/HomeBgImg.jpg") center top no-repeat;
}

#second-bg {
  background: url("./assets/TrendingBgImg.jpg") center top no-repeat;
}

@include respond-below(sm) {
  #second-bg {
    background: url("./assets/TrendingBgImg_sm.jpg") center top no-repeat;
  }

  // #forth-bg {
  //   display: flex;
  // }
  // .btn-wrap {
  //   margin-bottom: 15%;
  // }
}

#third-bg {
  background: url("./assets/NewBgImg.jpg") center top no-repeat;
}

#forth-bg {
  background: none;
  // display: flex;
  // justify-content: center;
}

.home-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -2;
  background: #2d0a04;
}

.trending-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -2;
  background: #cda780;
}

.new-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -2;
  background: #d0dfe4;
}

.member-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -2;
  background: #dbe0da;
}

@include respond-below(sm) {
  .footer-wrap {
    position: relative;
    .footer {
      display: flex;
      flex-direction: column;
      text-align: center;

      &-copyright {
        padding-top: 0;
        margin-top: 0;
        text-align: center;
        border-top: 0;
      }
    }
  }

  .web-bg {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  // .nav {
  //   // position: relative;
  //   // flex-direction: column;
  //   // &-item {
  //   // display: none;
  //   // .is-active {
  //   //   display: inline;
  //   // }
  //   // }
  // }

  .charge-wrap {
    &-row {
      margin: 0;
      flex-direction: column;
    }

    .charge-img {
      margin: 10px;
    }
  }

  #forth-bg {
    display: flex;
    justify-content: center;
    height: auto;
    background: #dbe0da;
  }
}
</style>
